export default "__VITE_ASSET__JpFTYYiW__"